import {Breadcrumb, BreadcrumbItem, Center, Flex, Text} from '@chakra-ui/react';
import {HeaderWrapper} from 'components/layouts';
import {colors} from 'components/providers';
import {useTranslation} from 'hooks';
import {FC} from 'react';
import {ICategoryByProviderResponse, ProviderTypeEnum} from 'types';
import LinkUI from 'ui/LinkUI';

import {Contact, DownloadApp, General, Information} from './components';

interface Props {
  categories?: ICategoryByProviderResponse[];
  providerType?: ProviderTypeEnum;
  isDesktop: boolean;
}

export const Footer: FC<Props> = ({categories = [], providerType, isDesktop}) => {
  const {t} = useTranslation();
  const showCategories = !!categories?.length;

  return (
    <Center as="footer" w="100%" maxW="100%" flexDirection="column">
      {showCategories && (
        <HeaderWrapper bg={colors.bodyBackground} w="full" innerbox={{h: 'auto'}} py="15px" justifyContent="center">
          <Breadcrumb
            separator="•"
            color={colors.textGray}
            spacing={['5px', '15px']}
            textAlign="center"
            sx={{
              ol: {
                flexWrap: 'wrap',
                justifyContent: 'center',
              },
            }}
          >
            {categories?.map((category) => {
              return (
                <BreadcrumbItem as="li" key={category.id} listStyleType="none" mb={['0px', '5px']} cursor="pointer">
                  <LinkUI
                    href={{
                      pathname: `${providerType === 'restaurant' ? `/category/${category.slug}` : `/${providerType}s`}`,
                      query:
                        providerType === 'market'
                          ? {
                              categorySlug: category.slug,
                              products: 'true',
                            }
                          : {},
                    }}
                  >
                    <Text fontSize={['14px', '16px']} _hover={{color: colors.pink}}>
                      {category.name}
                    </Text>
                  </LinkUI>
                </BreadcrumbItem>
              );
            })}
          </Breadcrumb>
        </HeaderWrapper>
      )}
      <HeaderWrapper bg="white" innerbox={{h: 'auto'}}>
        <Flex
          py="30px"
          pb="90px"
          bg={colors.white}
          justifyContent="space-between"
          alignItems="flex-start"
          flexDirection={isDesktop ? 'row' : 'column'}
          w="100%"
        >
          <Flex w={['100%', '45%']} justifyContent="space-between">
            <DownloadApp t={t} />
            <Information t={t} />
          </Flex>
          <Flex w={['100%', '45%']} justifyContent="space-between" mt={isDesktop ? '0px' : '20px'}>
            <General t={t} />
            <Contact t={t} />
          </Flex>
        </Flex>
      </HeaderWrapper>
    </Center>
  );
};
